import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-scroll';
import { FiGithub } from 'react-icons/fi';
import { FaLinkedinIn, FaBehance, FaDribbble, FaTiktok } from 'react-icons/fa';
import { HiMenuAlt3, HiX } from 'react-icons/hi';
import './Navbar.css';

const navLinks = [
  { name: 'HOME', to: 'hero' },
  { name: 'ABOUT', to: 'about' },
  { name: 'EXPERIENCE', to: 'experience' },
  { name: 'PROJECTS', to: 'projects' },
  { name: 'EXPERTISE', to: 'skills' },
  { name: 'EDUCATION', to: 'education' },
  { name: 'CONTACT', to: 'contact' },
];

const socials = [
  { icon: <FiGithub />, href: 'https://github.com/emarcj0-debug', label: 'GitHub' },
  { icon: <FaLinkedinIn />, href: 'https://www.linkedin.com/', label: 'LinkedIn' },
  { icon: <FaDribbble />, href: '#', label: 'Dribbble' },
  { icon: <FaBehance />, href: '#', label: 'Behance' },
  { icon: <FaTiktok />, href: '#', label: 'TikTok' },
];

const Navbar = () => {
  const [isMobileOpen, setIsMobileOpen] = useState(false);

  return (
    <>
      {/* Desktop Sidebar */}
      <motion.nav
        className="sidebar-nav"
        initial={{ opacity: 0, x: -20 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.6, ease: 'easeOut' }}
      >
        {/* Nav Links */}
        <div className="sidebar-links">
          {navLinks.map((link) => (
            <Link
              key={link.name}
              to={link.to}
              smooth={true}
              duration={500}
              offset={-20}
              spy={true}
              activeClass="active"
              className="sidebar-link clickable"
            >
              <span className="sidebar-link-line" />
              <span className="sidebar-link-text">{link.name}</span>
            </Link>
          ))}
        </div>

        {/* Social Links */}
        <div className="sidebar-socials">
          {socials.map((s, i) => (
            <a
              key={i}
              href={s.href}
              target="_blank"
              rel="noopener noreferrer"
              className="sidebar-social clickable"
              aria-label={s.label}
            >
              {s.icon}
            </a>
          ))}
        </div>
      </motion.nav>

      {/* Mobile Top Bar */}
      <div className="mobile-topbar">
        <button
          className="mobile-toggle clickable"
          onClick={() => setIsMobileOpen(!isMobileOpen)}
          aria-label="Toggle menu"
        >
          {isMobileOpen ? <HiX size={24} /> : <HiMenuAlt3 size={24} />}
        </button>
      </div>

      {/* Mobile Menu Overlay */}
      <AnimatePresence>
        {isMobileOpen && (
          <motion.div
            className="mobile-menu"
            initial={{ opacity: 0, x: '-100%' }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: '-100%' }}
            transition={{ type: 'spring', damping: 25, stiffness: 200 }}
          >
            <div className="mobile-menu-content">
              {navLinks.map((link, index) => (
                <motion.div
                  key={link.name}
                  initial={{ opacity: 0, x: -30 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: index * 0.06 }}
                >
                  <Link
                    to={link.to}
                    smooth={true}
                    duration={500}
                    offset={-20}
                    className="mobile-link clickable"
                    onClick={() => setIsMobileOpen(false)}
                  >
                    {link.name}
                  </Link>
                </motion.div>
              ))}

              <div className="mobile-socials">
                {socials.map((s, i) => (
                  <a
                    key={i}
                    href={s.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="sidebar-social clickable"
                    aria-label={s.label}
                  >
                    {s.icon}
                  </a>
                ))}
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default Navbar;
